<template>
    <the-layout-dashboard-account>
        <template slot="name">
            {{ tenant.name }}
        </template>

        <template slot="persona">
            Tenant
        </template>

        <template slot="dropdown">
            <laroute-link
                :to="{
                    name: 'auth.personas.index'
                }"
                class="dropdown-menu-link"
            >
                Switch profile
            </laroute-link>
            <laroute-link
                :to="{
                    name: 'auth.personas.create'
                }"
                class="dropdown-menu-link"
            >
                New profile
            </laroute-link>
        </template>
    </the-layout-dashboard-account>
</template>

<script>
    import _ from 'lodash'
    import * as types from '../store/types'
    import TheLayoutDashboardAccount from './the-layout-dashboard-account'

    export default {
        components: {
            TheLayoutDashboardAccount
        },
        computed: {
            tenant () {
                return _.get(this.$store.getters[types.tenants.modules.current.getters.item], 'data')
            }
        }
    }
</script>
